export default {
  label: {
    sentimentText: 'Sentiment',
  },
};
